import { cn } from "@/app/lib/utils";

interface SkeletonProps {
  className?: string;
}

export function Skeleton({ className }: SkeletonProps) {
  return (
    <div className={cn("animate-pulse rounded-md bg-gray-200", className)} />
  );
}

export function SkeletonText({ className }: SkeletonProps) {
  return <Skeleton className={cn("h-4 w-full", className)} />;
}

export function SkeletonCircle({ className }: SkeletonProps) {
  return <Skeleton className={cn("h-10 w-10 rounded-full", className)} />;
}

export function SkeletonButton({ className }: SkeletonProps) {
  return <Skeleton className={cn("h-10 w-full rounded-md", className)} />;
}

export function SkeletonImage({ className }: SkeletonProps) {
  return <Skeleton className={cn("h-40 w-full rounded-md", className)} />;
}

export function SkeletonCard({ className }: SkeletonProps) {
  return <Skeleton className={cn("h-[200px] w-full rounded-lg", className)} />;
}

export function SkeletonAvatar({ className }: SkeletonProps) {
  return <Skeleton className={cn("h-12 w-12 rounded-full", className)} />;
}

export function SkeletonTitle({ className }: SkeletonProps) {
  return <Skeleton className={cn("h-8 w-3/4 rounded-md", className)} />;
}

export function SkeletonSubtitle({ className }: SkeletonProps) {
  return <Skeleton className={cn("h-6 w-1/2 rounded-md", className)} />;
}

export function SkeletonParagraph({ className, lines = 3 }: SkeletonProps & { lines?: number }) {
  return (
    <div className="space-y-2">
      {Array.from({ length: lines }).map((_, i) => (
        <SkeletonText key={i} className={cn(i === lines - 1 && "w-4/5", className)} />
      ))}
    </div>
  );
} 